module.exports = __webpack_public_path__ + "files/6243ec1422c234d56263cdb35b378c79.svg";